import React, { useContext, useState, useEffect } from 'react'
import { AgendaContext } from '../context/AgendaContext'
import { v4 as uuidv4 } from 'uuid'
import UpcomingForm from './forms/UpcomingForm';
import DocActionMenu from './DocActionMenu';
import ToggleForm from './ToggleForm';
import { MeetingsWrapper } from '../styles/TableStyle';
import { useTranslation } from 'react-i18next';

const UpComingSweMeetings = () => {
    const { t } = useTranslation(); 
    const { upComingSweMeetings, setUpComingSweMeetings } = useContext(AgendaContext);
    const [editItem, setEditItem] = useState({
        id: null,
        end_date: '',
        name: '',
        start_date: '',
        presence_type: '',
        location: '',

    })
    const [newItem, setNewItem] = useState({
        id: null,
        end_date: '',
        name: '',
        start_date: '',
        presence_type: '',
        location: '',

    })

    useEffect(() => {
        const storedItems = JSON.parse(localStorage.getItem('upcoming_swe_meetings')) || []

        if (storedItems.length > 0) {
            setUpComingSweMeetings((prevItems) => {
                const mergeItems = prevItems.map((doc) => {
                    const localStorageItems = storedItems.find((item) => item.id === doc.id)

                    if (localStorageItems && JSON.stringify(localStorageItems) !== JSON.stringify(doc)) {
                        return localStorageItems
                    }

                    return doc
                })
                const newItems = storedItems.filter((stored) => !prevItems.some((doc) => doc.id === stored.id))
                return [...mergeItems, ...newItems]
            })
        }
    }, [setUpComingSweMeetings]);

    const handleEditCancel = () => {
        setEditItem(prev => ({
            ...prev, 
            id: null
        })); 
    }; 

    const submitEditTask = (event) => {
        event.preventDefault();
        const { end_date, name, start_date, presence_type, location } = editItem

        setUpComingSweMeetings((prevItems) => {
            const items = prevItems.map((item) => {
                if (item.id === editItem.id) {
                    const updatedItem = {
                        ...item,
                        end_date,
                        name,
                        start_date,
                        presence_type,
                        location,
                    }

                    const getItem = JSON.parse(localStorage.getItem('upcoming_swe_meetings'))
                    const existingIndex = getItem.findIndex(i => i.id === updatedItem.id)
                    if (existingIndex !== -1) {
                        getItem[existingIndex] = updatedItem;
                    } else {
                        getItem.push(updatedItem)
                    }
                    localStorage.setItem('upcoming_swe_meetings', JSON.stringify(getItem))
                    return updatedItem
                }
                return item
            })
            return items
        })
        setEditItem({
            id: null,
            end_date: '',
            name: '',
            start_date: '',
            presence_type: '',
            location: '',

        })
    }

    const submitNewTask = (event) => {
        event.preventDefault();
        const { end_date, name, start_date, presence_type, location } = newItem; 
        const newDoc = {
            id: uuidv4(),
            end_date,
            name,
            start_date,
            presence_type,
            location,
        }

        setUpComingSweMeetings((prevItems) => {
            const addNewDoc = [...prevItems, newDoc];
            const storedItems = JSON.parse(localStorage.getItem('upcoming_swe_meetings')) || [];
            const updatedStoredDocs = [...storedItems, newDoc]
            localStorage.setItem('upcoming_swe_meetings', JSON.stringify(updatedStoredDocs))
            return addNewDoc
        })

        setNewItem({
            id: null,
            end_date: '',
            name: '',
            start_date: '',
            presence_type: '',
            location: '',
        })
    }

    const handleNewTaskChange = (event) => {
        const { name, value, type, checked } = event.target
        setNewItem({
            ...newItem,
            [name]: type === 'checkbox' ? checked : value
        })
    }

    const handleEditTaskChange = (event) => {
        const { name, value, type, checked } = event.target
        setEditItem({
            ...editItem,
            [name]: type === 'checkbox' ? checked : value
        })
    }

    const handleEditTaskClick = (item) => {
        setEditItem({
            id: item.id,
            end_date: item.end_date,
            name: item.name,
            start_date: item.start_date,
            presence_type: item.presence_type,
            location: item.location,
        })
    }

    const handleDeleteTask = (id) => {
        const deleteItem = upComingSweMeetings.filter((item) => item.id !== id);
        setUpComingSweMeetings(deleteItem);
        localStorage.setItem('upcoming_swe_meetings', JSON.stringify(deleteItem));
    }

    const renderUpComingSweMeetings = () => {
        return upComingSweMeetings.map((item, index) => {
            const [date, time] = item.start_date.split('T')
            return (
                <MeetingsWrapper key={index}>
                    {editItem.id === item.id ? (
                        <UpcomingForm
                            theme='lightBlue'
                            submitTask={submitEditTask}
                            handleTaskChange={handleEditTaskChange}
                            handleEditCancel={handleEditCancel}
                            item={editItem}
                            message={`${t('common.edit')} ${t('upComingMeeting.swedishMeeting')} #${index + 1}`}
                            type='national'
                            isEditing={editItem.id === item.id}
                        />
                    ) : (
                        <>
                            <h6 className='cell cell-header cell-left'>{item.name}</h6>
                            <h6 className='cell cell-header'>
                                {`${date}, kl. ${time}\u0020`}
                                <span>{item.presence_type === 'FACE_TO_FACE' ? 'F2F' : item.presence_type}</span>
                            </h6>
                            <div className='cell cell-last-item'>
                                <DocActionMenu
                                    item={item}
                                    handleDeleteText={handleDeleteTask}
                                    handleEditTextClick={handleEditTaskClick}
                                />
                            </div>
                            <span className='cell cell-bottom cell-left'>{item.location}</span>
                            <div className='cell cell-bottom'>
                            </div>
                            <div className='cell cell-last-item'></div>
                        </>
                    )}

                </MeetingsWrapper>
            )
        })
    }
    return (
        <div>
            {upComingSweMeetings && upComingSweMeetings.length > 0 ? (
                <div>
                    {renderUpComingSweMeetings()}
                </div>
            ): (
                <span>{t('common.noContent')}</span>
            )}
            <ToggleForm>
                <UpcomingForm 
                    theme='darkBlue'
                    submitTask={submitNewTask}
                    handleTaskChange={handleNewTaskChange}
                    item={newItem}
                    message={`${t('common.addBtnLabel')} ${t('upComingMeeting.swedishMeeting')}`}
                    type='national'
                />
            </ToggleForm>
        </div>
    )
}

export default UpComingSweMeetings